const acc = document.getElementsByClassName("accordion");
let i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        let e = this.nextElementSibling;

		if(typeof jQuery == "function") {
			jQuery(e).slideToggle();
		}
		else {
			if (e.style.display === "block") {
				e.style.display = "none";
			} else {
				e.style.display = "block";
			}
		}
    });
}